import React from 'react';
import { ToastContainer } from 'react-toastify';
import AppRouter from './routes/AppRoutes';
import { AuthInit } from './modules/auth/AuthContext';
import { PoleProvider } from './modules/poles/PolesContext';
import { DataProvider } from './modules/data/DataContext';
import { EquipmentProvider } from './modules/equipment/EquipmentContext';

const App: React.FC = () => {
  return (
    <AuthInit>
      <EquipmentProvider>
        <PoleProvider>
          <DataProvider>
            <AppRouter />
            <ToastContainer
              position="bottom-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              limit={3}
            />
          </DataProvider>
        </PoleProvider>
      </EquipmentProvider>
    </AuthInit>
  );
};

export default App;
